import React from "react";
import { Box, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { getTypeColor } from "../../../constants/colors";

/**
 * isNew = true  → NEW（ガラス / 太字 / glow / ドットあり）
 * isNew = false → 閲覧済み（フラット / ドットなし）
 */
const StatusChip = ({ isNew, type }) => {
  const theme = useTheme();
  const mainColor = getTypeColor(type);

  const label = isNew ? "NEW" : "閲覧済み";

  const textColor = isNew ? mainColor : theme.palette.text.secondary;

  return (
    <Box
      sx={{
        fontSize: { xs: "0.6rem", sm: "0.75rem" },
        borderRadius: "999px",
        fontWeight: isNew ? 700 : 500,
        py: { xs: 0.3, sm: 0.4 },
        px: { xs: 0.9, sm: 1.2 },
        display: "inline-flex",
        alignItems: "center",
        gap: 0.6,
        whiteSpace: "nowrap",
        color: textColor,

        /* NEW */
        ...(isNew && {
          background: alpha(mainColor, 0.08),
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          border: `1px solid ${alpha(mainColor, 0.7)}`,
          boxShadow: `
            0 3px 8px ${alpha(mainColor, 0.14)},
            inset 0 1px 1px ${alpha("#fff", 0.28)}
        `,
        }),

        /* 既読 */
        ...(!isNew && {
          backgroundColor: alpha(theme.palette.text.secondary, 0.1),
          boxShadow: "none",
          border: "none",
        }),
      }}
    >
      {/* ドットは NEW のときだけ */}
      {isNew && (
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: mainColor,
            flexShrink: 0,
          }}
        />
      )}

      <Box component="span">{label}</Box>
    </Box>
  );
};

export default StatusChip;
